import React, { useState, useEffect } from 'react'
import Header from '../component/header';
import "../assets/css/referearn.css";
import { jwtDecode } from "jwt-decode";
import axios from 'axios';
import configModule from '../../config.js';
import { Toaster, toast } from "react-hot-toast";

function ReferandEarn() {
    const [usersData, setUsersData] = useState(null);
    const [referralsData, setReferralsData] = useState([]);
    const config = configModule.config();

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (token) {
            const decoded = jwtDecode(token);
            setUsersData(decoded);
        }
    }, []);

    const getReferralsData = async () => {

        try {
            const response = await axios.post(
                `${config.apiBaseUrl}/get-getreferrals`,
                {
                    investorId: usersData?.investorId || -1,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            const data = response.data?.data || [];
            setReferralsData(data);

        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Something went wrong";

            toast.error(message);
        }
    };

    useEffect(() => {
        if (usersData?.id) {
            getReferralsData();
        }
    }, [usersData]);

    const handleCopyCode = async () => {
        try {
            await navigator.clipboard.writeText(usersData?.investorId);
            alert("Referral code copied!");
        } catch (error) {
            console.error("Failed to copy referral code:", error);
        }
    };

    return (
        <div className='dashboardmain-st'>
            <Header pageName="Refer & Earn" />
            <div className="body-dashboard">
                <div className="page-header">
                    <div className="page-eyebrow">Explore</div>
                    <div className="page-title">Refer & Earn</div>
                </div>

                <div className="lxp-referral-code">
                    <div>
                        <div className="lxp-referral-code-text">{usersData?.investorId || ""}</div>
                        <div className="lxp-referral-sub">Share your code — when someone you refer completes an investment, you both earn a
                            reward.</div><button className="lxp-btn lxp-btn-gold lxp-btn-sm"
                                style={{ marginTop: "14px", position: "relative", zIndex: "1" }} onClick={handleCopyCode} >Copy Code</button>
                    </div>
                </div>

                <div className="lxp-referral-steps" style={{ marginBottom: "0" }}>
                    <div className="lxp-referral-step">
                        <div className="lxp-referral-step-num">1</div>
                        <div className="lxp-referral-step-title">Share your code</div>
                        <div className="lxp-referral-step-sub">Send your referral code to friends or family considering real-estate
                            investment.</div>
                    </div>
                    <div className="lxp-referral-step">
                        <div className="lxp-referral-step-num">2</div>
                        <div className="lxp-referral-step-title">They invest</div>
                        <div className="lxp-referral-step-sub">Your relationship manager guides them through onboarding and their first
                            investment.</div>
                    </div>
                    <div className="lxp-referral-step">
                        <div className="lxp-referral-step-num">3</div>
                        <div className="lxp-referral-step-title">You both earn</div>
                        <div className="lxp-referral-step-sub">Once their investment is confirmed, your reward is credited to your account.
                        </div>
                    </div>
                </div>

                <div className="chart-card overflow-auto mt-3" style={{ background: "#fff" }}>
                    <div className="card-header-st" style={{ minWidth: "732px" }}>
                        <div>
                            <div className="card-title-st">Your Referrals</div>
                        </div>
                    </div>

                    <div className="chart-table-st" style={{ minWidth: "732px" }}>
                        <div className="d-flex w-100">
                            <div className="w-30 d-center comcolldbtab-st hdcoldbtab-st">Name</div>
                            <div className="w-30 d-center comcolldbtab-st hdcoldbtab-st">Total Invesment</div>
                            <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Inv. Status</div>
                            <div className="w-20 d-center comcolldbtab-st hdcoldbtab-st">Reward Status</div>
                        </div>
                        <div className="d-flex w-100">
                            {referralsData?.length > 0 ? referralsData.map((item, index) => (
                                <div key={index} className='w-100 d-flex' >
                                    <div className="w-30 d-center comcolldbtab-st bdycoldbtab-st">{item?.full_name}</div>
                                    <div className="w-30 d-center comcolldbtab-st bdycoldbtab-st">₹ {item?.total_invesment}</div>
                                    <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">
                                        <span
                                            className={
                                                item.ref_status === "Invested"
                                                    ? "pill pill-active"
                                                    : item.ref_status === "Pending"
                                                        ? "pill pill-pending"
                                                        : "pill pill-delayed"
                                            }
                                        >
                                            {item.ref_status}
                                        </span>

                                    </div>
                                    <div className="w-20 d-center comcolldbtab-st bdycoldbtab-st">
                                        <span
                                            className={
                                                item.ref_reward === "Paid"
                                                    ? "pill pill-active"
                                                    : item.ref_reward === "Pending"
                                                        ? "pill pill-pending"
                                                        : "pill pill-delayed"
                                            }
                                        >
                                            {item.ref_reward}
                                        </span>
                                    </div>
                                </div>
                            )) : (
                                <div className='w-100 d-center comcolldbtab-st bdycoldbtab-st'>
                                    No data found.
                                </div>
                            )}
                            {/* <div className="w-45 d-center comcolldbtab-st bdycoldbtab-st">Priya Menon</div>
                            <div className="w-30 d-center comcolldbtab-st bdycoldbtab-st">2026-07-02</div>
                            <div className="w-25 d-center comcolldbtab-st bdycoldbtab-st">Pending</div> */}
                        </div>
                    </div>
                </div>

            </div>

            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 3000,
                    style: {
                        background: "#0a1628",
                        color: "#fff",
                        borderRadius: "10px",
                        padding: "14px 18px",
                    },
                    success: {
                        iconTheme: {
                            primary: "#22c55e",
                            secondary: "#fff",
                        },
                    },
                    error: {
                        iconTheme: {
                            primary: "#ef4444",
                            secondary: "#fff",
                        },
                    },
                }}
            />
        </div>
    )
}

export default ReferandEarn;
